import { SettingOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import "../styles.scss";
import MegaTable from "../../../components/MagaTableV2";

const VehicleInformationyTabs = ({ stData = {} as any }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.ownership_type_detail?.list.map((col: any) => {
      if (col.field === 'vehicle_model') {
        temp.push({
          field: "vehicle_model", headerName: col.headerName, cellRenderer: (params: any) => {
            if (params.data.vehicle_model === 'TB') {
              return 'Tải Bus'
            } else if (params.data.vehicle_model === 'DL') {
              return 'Du lịch'
            } else {
              return params.data.vehicle_model
            }
          }
        })
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheVehicleInformationyTabs',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "vehicle_name", headerName: "Tên xe" },
      // { field: "cus_name", headerName: "Chủ sở hữu" },
      // { field: "customer_interactions_box_code", headerName: "Thùng" },
      // { field: "chassis_no", headerName: "Số khung (VIN)" },
      // { field: "number_plate", headerName: "Biển số xe" },
      // { field: "vehicle_brand", headerName: "Thương hiệu" },
      // { field: "color_name", headerName: "Màu xe" },
      // { field: "branch_name", headerName: "Đơn vị dùng dịch vụ" },
      // {
      //   field: "vehicle_model", headerName: "Dòng xe", cellRenderer: (params: any) => {
      //     if (params.data.vehicle_model === 'TB') {
      //       return 'Tải Bus'
      //     } else if (params.data.vehicle_model === 'DL') {
      //       return 'Du lịch'
      //     } else {
      //       return params.data.vehicle_model
      //     }
      //   }
      // },
      // { field: "engine_no", headerName: "Số máy" },
      // { field: "engine_type", headerName: "Loại động cơ" },
      // { field: "made_year", headerName: "Năm sản xuất" },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });
  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: stData.xesudung_show && stData.xesudung_show.vehicle_name ? [stData.xesudung_show] : [] }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default VehicleInformationyTabs;
